export const clientServiceRouteName = {
  index: "client-services.index",
};

export const clientServiceRoute = [
  {
    path: "/client-services",
    name: clientServiceRouteName.index,
    component: () => import("../pages/DataTablePage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "client_service",
      breadcrumbs: () => {
        return [{ title: "Client Service" }];
      },
    },
  },
];
